export default __webpack_public_path__ + "static/media/edit.cfc2c71a.svg";